import { app } from '../../../../../../app';
import { Controller } from './edit-profile-attributes.controller';

app.component('companyUserDirectoriesManageAccountProfileAttributesEdit', {
    bindings: {
        accountId: '<',
        companyId: '<',
        profileAttributes: '<',
    },
    controller: Controller,
    templateUrl: require('./edit-profile-attributes.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-account/profile-attributes/edit/edit-profile-attributes.component.js